import React, { Component } from "react";
import { connect } from "react-redux";
import GetTime from "../../GetTime.js";
import { NavLink } from "react-router-dom";
import { actionDeliverySuccessDetails } from "../../../actions/index";
import { bindActionCreators } from "redux";
import notification from "../../../images/notifications_white.svg";
import api from "../../../utility/api/api.js";
import SignaturePad from "react-signature-pad";
import { Label } from "reactstrap";
import Loader from "react-loader";
import StarRatingComponent from "react-star-rating-component";
class DeliverySuccess extends Component {
  constructor(props) {
    super(props);
    this.state = {
      error: "",
      rating: 0,
      delayReason: "",
      signData: "",
      signFeedbackstate: "",
    };
    this.masterData = JSON.parse(localStorage.getItem("getMasterData"));
    this.load = true;
  }
  clear = () => {
    this.refs.customerSignature.clear();
  };
  componentWillReceiveProps(nextprops) {
    let localData = localStorage.getItem("orderData");
    if (localData && this.load) {
      localData = JSON.parse(localData);
      if (localData.deliverysuccess) {
        nextprops.actionDeliverySuccessDetails(localData.deliverysuccess);
        this.load = false;
      }
    }
  }
  getSignatureData() {
    let customer = this.refs.customerSignature;
    let data = customer.toDataURL("base64String");
    console.log("datata", data);
    return data;
  }
  sendCustomerExpData() {
    let trip_id = this.props.orderData.job_order_id;
    let orderfeedback = {};
    let delayReasonData = document.querySelector(
      "input[name='delivery_order_delay_reason']:checked"
    );
    if (delayReasonData) {
      delayReasonData = delayReasonData.value;
    }
    // orderfeedback.job_order_id=trip_id;
    // orderfeedback.reason=delayReasonData;
    // orderfeedback.rating=this.state.rating == 0 ? null : this.state.rating;
    // orderfeedback.image_name=order_id+'_'+trip_id+'_img.png';
    orderfeedback.job_order_id = trip_id;
    orderfeedback.customer_signature = this.getSignatureData();
    console.log("orderfeedback", orderfeedback);
    api.feedback(this, orderfeedback);
    // this.props.actionDeliverySuccessDetails(null);
  }

  render() {
    if (
      this.state.signFeedbackstate &&
      this.state.signFeedbackstate == "success"
    ) {
      this.props.history.push("/intransit");
    }
    let { trimmedDataURL, rating } = this.state;
    const orderData = Object.assign({}, this.props.orderData);
    console.log("orderData", orderData);
    const deliver = orderData.amountToBe_collected ? false : true;
    //  const { rating } = this.state.rating;
    if (orderData && this.props.deliveryDetails) {
      const {
        order_increment_id,
        date,
        time,
        transaction_type,
        transaction_id,
        delay_minute,
        amount_paid,
      } = this.props.deliveryDetails;
      return (
        <div className="container mw-100">
          <div className="rider-header position-fixed deliver-custom-header">
            <div className="header-left-side">
              <div>
                <NavLink to="/intransit">
                  <i className="text-white float-left pt-1 pr-3 icon-prevarrow back-btn-arrow"></i>
                </NavLink>
                <span className="text-white hub-header-title">
                  Order Success
                </span>
                <img
                  className="float-right pt-1"
                  // src={notification}
                  // alt="notification"
                />
              </div>
            </div>
          </div>
          <div className="maincontent deliver-order-comp">
            <div className="successfull_delivery_info p-3">
              <div className="success_message">
                <span className="icon-checked success_icon"></span>
                <p className="success_msg mt-2 mb-2 ">Delivered Successfully</p>
              </div>
              {transaction_type != "NULL" && parseFloat(amount_paid) > 0 && (
                <div className="payment_recieved_mode pt-3 pb-3">
                  Recieved successfully by {transaction_type} {amount_paid}
                </div>
              )}
              <div className="success_order_details px-4 py-3">
                <div className="order_details1">
                  <div className="order_info mb-4">
                    <p className="o_label m-0">Orders Id: </p>
                    <p className="o_val m-0">{order_increment_id}</p>
                  </div>
                  {transaction_type != "NULL" && (
                    <div className="order_info">
                      <p className="o_label m-0">Payment Mode: </p>
                      <p className="o_val m-0">{transaction_type}</p>
                    </div>
                  )}
                </div>
                <div className="order_details2">
                  <div className="order_info mb-4">
                    <p className="o_label m-0">Delivery Date: </p>
                    <p className="o_val m-0">{date}</p>
                  </div>
                  {transaction_id != null && transaction_id != "NULL" && (
                    <div className="order_info">
                      <p className="o_label m-0">Txn. Id: </p>
                      <p className="o_val m-0">{transaction_id}</p>
                    </div>
                  )}
                </div>
                <div className="order_details3">
                  <div className="order_info mb-4">
                    <p className="o_label m-0"> Delivery Time: </p>
                    <p className="o_val m-0">{time}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {!parseInt(delay_minute) ? (
            ""
          ) : (
            <div className="delay_reason_container px-4 pt-0 pb-3 mx-3">
              <div className="select-reason-title pb-3">
                Select Reason to order Delayed by {delay_minute}
              </div>
              {this.masterData.reasons.delivery_order_delay_reason.map(
                (obj, key) => (
                  <div key={key}>
                    <div className="reason_check pb-3">
                      <input
                        className="with-gap custom-check"
                        onChange={(e) => this.setState({ error: "" })}
                        value={obj.reason ? obj.reason : obj}
                        id={`delivery_order_delay_${key}`}
                        name="delivery_order_delay_reason"
                        type="radio"
                      />
                      <Label htmlFor={`delivery_order_delay_${key}`}>
                        {obj.reason ? obj.reason : obj}
                      </Label>
                    </div>
                  </div>
                )
              )}
            </div>
          )}

          <div className="text-danger">{this.state.error}</div>
          <div className="sign-pad-container p-4">
            <SignaturePad
              canvasProps={{
                width: "275",
                height: "160",
                className: "sigCanvas",
              }}
              ref="customerSignature"
            />
            <span className="customer_sign_label">CUSTOMER SIGN HERE</span>
            <div className="clear_btn_container px-4">
              <a className="clear_button float-right p-3" onClick={this.clear}>
                Clear
              </a>
            </div>
          </div>
          <div className="rating-stars-container">
            <span className="rating_label pb-2">Rate Your Experience</span>
            <StarRatingComponent
              name="rate1"
              starCount={5}
              value={rating}
              onStarClick={(rating) => this.setState({ rating })}
            />
          </div>
          {trimmedDataURL ? <img src={trimmedDataURL} /> : null}
          <div className="sodexo_btn_container">
            <button
              className="sodexo_continue_btn"
              onClick={(e) => this.sendCustomerExpData()}
            >
              CLOSE
            </button>
          </div>
        </div>
      );
    } else {
      return (
        <div className="container mw-100">
          <div className="rider-header position-fixed deliver-custom-header">
            <div className="header-left-side">
              <div>
                <NavLink to="/intransit">
                  <i className="text-white float-left pt-1 pr-3 icon-prevarrow back-btn-arrow"></i>
                </NavLink>
                <span className="text-white hub-header-title">
                  Order Success
                </span>
                <img
                  className="float-right pt-1"
                  // src={notification}
                  // alt="notification"
                />
              </div>
            </div>
          </div>
          <Loader
            loaded={false}
            lines={13}
            length={20}
            width={10}
            radius={30}
            corners={1}
            rotate={0}
            direction={1}
            color="#e51837"
            speed={1}
            trail={60}
            shadow={false}
            hwaccel={false}
            className="spinner"
            zIndex={2e9}
            top="50%"
            left="50%"
            scale={1.0}
            loadedClassName="loadedContent"
          />
        </div>
      );
    }
  }
}
function mapStateToProps(state) {
  console.log("masterorder", state);
  return {
    orderData: state.orderDetails,
    deliveryDetails: state.deliveryDetails,
  };
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { actionDeliverySuccessDetails: actionDeliverySuccessDetails },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(DeliverySuccess);



// WEBPACK FOOTER //
// ./src/components/Intransit/DeliverySuccess/DeliverySuccess.js